// Menu configuration for sidebar navigation
// Section captions use isHeader (non-clickable); modules stay flat with their own subitems.

const QMS_MODULES = [
  {
    name: 'Dashboard',
    icon: 'M3 4a1 1 0 011-1h16a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zM3 10a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6zM14 9a1 1 0 00-1 1v6a1 1 0 001 1h6a1 1 0 001-1v-6a1 1 0 00-1-1h-6z',
    href: '/',
  },
  {
    name: 'Approvals',
    icon: 'M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z',
    subitems: [
      { name: 'My Approvals', href: '/approval/my-approvals' },
      { name: 'Approval Requests', href: '/approval/approval-requests' },
      { name: 'Approval Templates', href: '/approval/templates' },
      { name: 'Approval Analytics', href: '/approval/analytics' },
    ],
  },
  {
    name: 'Documents',
    icon: 'M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z',
    href: '/documents',
  },
  {
    name: 'Procedures',
    icon: 'M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z',
    subitems: [
      { name: 'Procedures', href: '/procedures' },
      { name: 'My Procedures', href: '/my-procedures' },
    ],
  },
  {
    name: 'Complaints',
    icon: 'M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z',
    subitems: [
      { name: 'Complaints', href: '/complaint' },
      { name: 'Depositors', href: '/depositor' },
      { name: 'Distributors', href: '/distributor' },
    ],
  },
  {
    name: 'Risk Assessments',
    icon: 'M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.464 0L4.35 16.5c-.77.833.192 2.5 1.732 2.5z',
    href: '/risk-assessment',
  },
  {
    name: 'Deviations',
    icon: 'M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.464 0L4.35 16.5c-.77.833.192 2.5 1.732 2.5z',
    href: '/deviation',
  },
  {
    name: 'CAPA Effectiveness',
    icon: 'M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z',
    href: '/capa-effectiveness-check',
  },
  {
    name: 'Change Request',
    icon: 'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4',
    href: '/change-request',
  },
  {
    name: 'Product Status Change',
    icon: 'M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z',
    href: '/product-status-change',
  },
  {
    name: 'CAPA Plan',
    icon: 'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4',
    href: '/external-audit',
  },
  {
    name: 'Returned Product Inspection',
    icon: 'M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4',
    href: '/returned-product-inspection',
  },
  {
    name: 'Trainings',
    icon: 'M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253',
    subitems: [
      { name: 'Employees', href: '/training-management/employee' },
      { name: 'Trainings', href: '/training-management/training' },
      { name: 'Training Assignments', href: '/training-assignment' },
    ],
  },
  {
    name: 'Reports & Analytics',
    icon: 'M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z',
    href: '/reports',
    subitems: [
      { name: 'All Reports', href: '/reports' },
      { name: 'Complaints', href: '/reports/complaint' },
      { name: 'Risk Assessments', href: '/reports/risk-assessment' },
      { name: 'Deviations', href: '/reports/deviation' },
      { name: 'Product Status Change', href: '/reports/product-status-change' },
      { name: 'Todos', href: '/reports/todo' },
      { name: 'Ticketing', href: '/reports/ticketing' },
      { name: 'Manuals', href: '/reports/manuals' },
      { name: 'Contracts', href: '/reports/contracts' },
    ],
  },
];

const OPERATIONS_MODULES = [
  {
    name: "Todo's",
    icon: 'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4',
    subitems: [
      { name: "Todo's List", href: '/todo' },
      { name: "Todo's Calendar", href: '/todo/calendar' },
    ],
  },
];

const IT_MODULES = [
  {
    name: 'Ticketing',
    icon: 'M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z',
    ticketingMergeDepartments: true,
    subitems: [
      { name: 'Ticketing Dashboard', href: '/ticketing/dashboard' },
      { name: 'All tickets (IT)', href: '/ticketing/it/queue' },
      { name: 'Ticketing setup', href: '/ticketing/options' },
    ],
  },
  {
    name: 'Manuals',
    icon: 'M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253',
    subitems: [
      { name: 'Manuals', href: '/manual' },
      { name: 'Manual Types', href: '/manual-type' },
      { name: 'My Manuals', href: '/my-manuals' },
    ],
  },
  {
    name: 'Contracts',
    icon: 'M19 5H5c-1.1 0-2 .9-2 2v10a2 2 0 002 2h14a2 2 0 002-2V7c0-1.1-.9-2-2-2zm-8 10H7v-2h4v2zm6-4H7V9h10v2z',
    subitems: [
      { name: 'Contract Dashboard', href: '/contract-dashboard' },
      { name: 'Contracts', href: '/contract' },
      { name: 'Contract Categories', href: '/contract-category' },
      { name: 'Entities', href: '/supplier' },
      { name: 'Entity Ratings', href: '/supplier-rating' },
    ],
  },
];

const ADMIN_MODULES = [
  {
    name: 'Administration',
    icon: 'M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z',
    subitems: [
      { name: 'User Management', href: '/users' },
      { name: 'User Permissions', href: '/admin/user-permissions' },
      { name: 'Roles', href: '/admin/roles' },
      {
        name: 'Configuration',
        icon: 'M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 100 4m0-4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 100 4m0-4v2m0-6V4',
        subitems: [
          {
            name: 'General',
            icon: 'M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z',
            subitems: [
              { name: 'Entity Types', href: '/admin/entity-types' },
              { name: 'Priorities', href: '/admin/priorities' },
              { name: 'Document Modules', href: '/admin/document-modules' },
              { name: 'Departments', href: '/departments' },
              { name: 'User Departments', href: '/admin/user-departments' },
            ],
          },
          {
            name: 'Documents',
            icon: 'M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z',
            subitems: [
              { name: 'Document Types', href: '/admin/document-types' },
              { name: 'Document Status', href: '/admin/document-status' },
            ],
          },
          {
            name: 'CAPA',
            icon: 'M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z',
            subitems: [
              { name: 'CAPA Types', href: '/admin/capa-types' },
              { name: 'CAPA Sources', href: '/admin/capa-sources' },
              { name: 'CAPA Status', href: '/admin/capa-status' },
              { name: 'CAPA Action Status', href: '/admin/capa-action-status' },
            ],
          },
          {
            name: 'Risk',
            icon: 'M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z',
            subitems: [
              { name: 'Risk Categories', href: '/admin/risk-categories' },
              { name: 'Risk Methodologies', href: '/admin/risk-methodologies' },
              { name: 'Risk Status', href: '/admin/risk-status' },
            ],
          },
          {
            name: 'NCR',
            icon: 'M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z',
            subitems: [
              { name: 'NCR Types', href: '/admin/ncr-types' },
              { name: 'NCR Status', href: '/admin/ncr-status' },
            ],
          },
          {
            name: 'Change',
            icon: 'M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z',
            subitems: [
              { name: 'Change Types', href: '/admin/change-types' },
              { name: 'Change Categories', href: '/admin/change-categories' },
              { name: 'Change Status', href: '/admin/change-status' },
            ],
          },
          {
            name: 'Complaint',
            icon: 'M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z',
            subitems: [
              { name: 'Types', href: '/admin/complaint-types' },
              { name: 'Status', href: '/admin/complaint-status' },
              { name: 'Sources', href: '/admin/complaint-sources' },
              { name: 'Category (Non-Medical)', href: '/admin/complaint-category-non-medical' },
              { name: 'Sample Available', href: '/admin/complaint-sample-available' },
              { name: 'Sample Inspection', href: '/admin/complaint-sample-inspections' },
              { name: 'Forward To', href: '/admin/complaint-forward-to' },
              { name: 'Finding Type', href: '/admin/complaint-finding-type' },
              { name: 'Investigation Category', href: '/admin/complaint-investigation-category' },
              { name: 'Action Type', href: '/admin/complaint-action-types' },
              { name: 'Action Taken Type', href: '/admin/complaint-action-taken-types' },
            ],
          },
          {
            name: 'Deviation',
            icon: 'M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z',
            subitems: [
              { name: 'Types', href: '/admin/deviation-types' },
              { name: 'Status', href: '/admin/deviation-status' },
              { name: 'Action Type', href: '/admin/deviation-action-types' },
              { name: 'Criticality', href: '/admin/deviation-criticality' },
              { name: 'Final Disposition', href: '/admin/deviation-final-disposition' },
            ],
          },
          {
            name: 'Training',
            icon: 'M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z',
            subitems: [{ name: 'Training Status', href: '/admin/training-status' }],
          },
          {
            name: 'Product Status Change',
            icon: 'M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z',
            subitems: [
              { name: 'Status', href: '/admin/product-status-change-status' },
            ],
          },
        ],
      },
    ],
  },
  {
    name: 'Settings',
    icon: 'M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z M15 12a3 3 0 11-6 0 3 3 0 016 0z',
    subitems: [
      { name: 'Application Settings', href: '/application-settings' },
      { name: 'Reference Documents', href: '/reference-documents' },
      { name: 'Email Templates', href: '/email-templates' },
      { name: 'Database Browser', href: '/database-browser' },
      { name: 'Database Migrations', href: '/database-migrations' },
    ],
  },
  {
    name: 'Report Scheduling',
    icon: 'M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z',
    subitems: [
      { name: 'Ticketing Report', href: '/report-scheduling/ticketing-status-analytics' },
      { name: 'Open Todos', href: '/report-scheduling/open-todos' },
      { name: 'Report Schedules', href: '/reports/schedules' },
    ],
  },
];

export const menuItems = [
  { name: 'QMS', isHeader: true, headerVariant: 'qms' },
  ...QMS_MODULES,
  { name: 'Operations', isHeader: true, headerVariant: 'operations' },
  ...OPERATIONS_MODULES,
  { name: 'IT', isHeader: true, headerVariant: 'it' },
  ...IT_MODULES,
  { name: 'Admin', isHeader: true, headerVariant: 'admin' },
  ...ADMIN_MODULES,
];

export const getMenuItemsByRole = (userRole = 'admin') => menuItems;
